import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function ComingSoon() {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 mb-6">
          <i className="ri-tools-line text-primary-600 text-2xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 uppercase mb-3">
          Em Breve
        </h1>
        <p className="text-foreground-500 text-sm max-w-md mb-8 leading-relaxed">
          Esta página está em desenvolvimento. Em breve você terá acesso a todo o conteúdo técnico e comercial sobre máquinas de solda geomembrana.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-bold px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
        >
          <i className="ri-arrow-left-line"></i>
          Voltar para Home
        </Link>
      </div>
    </Layout>
  );
}